import React,  { useState, useEffect} from 'react';
import { Card, Table, Row, Col, Button, Container } from 'react-bootstrap';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useFetchCase from '../hooks/useFetchCase';
import config from '../config';
import axios from 'axios';

function GeneralInfo({ caseId, onError = () => { } }) {

    const fetchUrl = `${config.API_URL}/CobraGeneralInformations/ByCaseId/${caseId}`;

    const [cobraGeneralInformation, setGeneralInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchGeneralInfo();
    }, [caseId]);

    const fetchGeneralInfo = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setGeneralInfo(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Skeleton count={10} />;
    if (error) return <div>{error}</div>;




    //const cobraGeneralInformation = plan?.cobraGeneralInformation || {};
    return (
        <Col lg={12} className="mb-3">
            <Card>
                <Card.Body>

                    <Row>
                        <Col lg={6}>
                            <Card.Title>General Information</Card.Title>
                        </Col>
                        <Col lg={6} className="text-end">
                            {/* Edit and delete buttons */}
                            {/* <Button
                                variant="link"
                                href="#"
                                className="cobra-summary-edit"
                                onClick={() => console.log('Edit clicked')}
                            >
                                <FaEdit />
                            </Button> */}
                            
                        </Col>
                    </Row>

                    <div className="table-responsive">
                    <table className="styled-table table-hover mb-0">
                            <tbody>
                                
                                <tr>
                                    <th className="" >
                                        We are currently receiving new qualifying events and newly eligible participants via {cobraGeneralInformation?.qbNpmFileSource}. Is this changing?
                                    </th>
                                    
                                    <td className="company">
                                        {cobraGeneralInformation.isChange === 'true' ? 'Yes' : 'No'}
                                    </td>
                                </tr>
                                {cobraGeneralInformation.isChange === 'true' && (
                                    <>
                                        <tr>
                                            <th className="">
                                                How will Clarity receive new qualifying events and newly eligible participants for the required notices?
                                            </th>
                                            
                                            <td className="cobra">
                                                {cobraGeneralInformation.clarityEventReceiptionMethod}
                                            </td>
                                        </tr>

                                        {cobraGeneralInformation.clarityEventReceiptionMethod === 'A third party vendor will provide an EDI File Feed' && (
                                            <>
                                                <tr>
                                                    <th className="">Vendor Name</th>
                                                    
                                                    <td className="cobra">{cobraGeneralInformation.vendorName}</td>
                                                </tr>
                                                <tr>
                                                    <th className="">Vendor Contact First Name</th>
                                                    
                                                    <td className="cobra">{cobraGeneralInformation.vendorContactFirstName}</td>
                                                </tr>
                                                <tr>
                                                    <th className="">Vendor Contact Last Name</th>
                                                    
                                                    <td className="cobra">{cobraGeneralInformation.vendorContactLastName}</td>
                                                </tr>
                                                <tr>
                                                    <th className="">Vendor Contact email address</th>
                                                    
                                                    <td className="cobra">{cobraGeneralInformation.vendorContactEmail}</td>
                                                </tr>
                                            </>
                                        )}
                                    </>
                                )}

{(cobraGeneralInformation?.qbNpmFileSource === "Manual Entry" ||
                            cobraGeneralInformation?.qbNpmFileSource === "Client Direct EDI" ||
                            cobraGeneralInformation?.qbNpmFileSource === "UNKNOWN" ||
                            cobraGeneralInformation?.qbNpmFileSource === null) && (
                                <>
                                <tr>
                                <th className="">
                                What is your current benefit administration platform?
                                    </th>
                                    
                                    <td>{cobraGeneralInformation?.currentBenefitAdministrationPlatform }</td>
                                </tr>
                                <tr>
                                <th className="">
                                What is your current payroll platform?
                                    </th>
                                    
                                    <td>{cobraGeneralInformation?.currentPayrollPlatform}</td>
                                </tr>
                                </>
                            )}

                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    )
}

export default GeneralInfo
